/**
 * OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPage
 *
 * Page component for OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPage
 * Path: /ar/docs/core-concepts/traits
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsTraitsARDocScreenView as __OrbDocCoreConceptsTraitsARDocScreenView } from '@/components/traits/OrbDocCoreConceptsTraitsARDocScreenView';
import { OrbDocCoreConceptsTraitsARDocAnalyticsView as __OrbDocCoreConceptsTraitsARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsTraitsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPage(_props: OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"السمات","description":"آلات حالات تتفاعل مع الأحداث، وتتحقق من الشروط، وتنفذ التأثيرات، وترسم الشاشة.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/traits"},{"locale":"ar","path":"/ar/docs/core-concepts/traits"},{"locale":"sl","path":"/sl/docs/core-concepts/traits"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsTraitsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsTraitsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default OrbDocCoreConceptsTraitsAROrbDocCoreConceptsTraitsARPage;
